import '@hoffmann/pattern-library-2/core.css';
import '@hoffmann/pattern-library-2/utils.css';
import './app/App.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as Sentry from "@sentry/react";
import { getHoffmanEnvironment } from './services/windowService';

// TEMPORARY (WSC-3017): Sentry is disabled regardless of the SENTRY_ENABLED
// environment variable. To re-enable, set this flag back to `false`.
const SENTRY_TEMPORARILY_DISABLED = true;

if (!SENTRY_TEMPORARILY_DISABLED && getHoffmanEnvironment().SENTRY_ENABLED === true) {
  Sentry.init({
    environment: getHoffmanEnvironment().ENVIRONMENT || 'not-set',
    dsn: 'https://f436cc7df38a0be3a4a422411705a5b7@o4504139853725696.ingest.us.sentry.io/4506948182081536',
    integrations: [
      Sentry.browserTracingIntegration(),
      //Sentry.replayIntegration({
      //  maskAllText: false,
      //  blockAllMedia: false,
      //}),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost',
      /^https:\/\/configurator-api-gateway\.qss\.dsp\.hoffmann-group\.com/,
      /^https:\/\/configurator-api-gateway\.dsp\.hoffmann-group\.com/
    ],
    // Session Replay
    //replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    //replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}


const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onSuccess: (registration: ServiceWorkerRegistration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
  onUpdate: (registration: ServiceWorkerRegistration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});
